import { Map, fromJS } from 'immutable';

export function clear() {
    return Map();
}
